export default __webpack_public_path__ + "static/media/room-sweet-apar_compressed.ae9d31af.mp4";